<div *ngIf="dataColumn.subHeader">
  <h4
    *ngIf="!dataColumn.subHeader[0].href"
    class="klarheit body b charcoal pb2 mb0"
  >
    {{ dataColumn.subHeader[0].title }}
  </h4>
  <a
    *ngIf="dataColumn.subHeader[0].href"
    jbStandaloneLink
    [jbSitemapLinker]="dataColumn.subHeader[0].href"
    class="body b royal-blue pb2 mb0"
  >
    {{ dataColumn.subHeader[0].title }}
  </a>
</div>
<ul class="list pa0 mv0">
  <jb-list-item [listItemData]="dataColumn.items"></jb-list-item>
</ul>
